import { isObject, get, isEqual, isEmpty, isNil, isNull } from 'lodash';
import { isMoment } from 'moment';
import { LookupModel } from '@eightcap/core';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
export class CommonHelper {
    static flattenObject(obj: any): any {
        const keys = CommonHelper.flattenKeys(obj);
        const flattenObj = {};
        keys.forEach((key: string) => {
            flattenObj[key] = get(obj, key);
        });

        return flattenObj;
    }
    static flattenKeys(obj: any): string[] {
        const flattened = [];
        Object.keys(obj).forEach((key) => {
            const value = obj[key];
            if (isObject(value) && !isMoment(value) && !Array.isArray(value)) {
                const internalKeys = CommonHelper.flattenKeys(value);
                internalKeys.forEach((internalKey: string) => {
                    flattened.push(`${key}.${internalKey}`);
                });
            } else {
                flattened.push(key);
            }
        });
        return flattened;
    }

    static parseJSON(json: any): any {
        let parsed;

        try {
            parsed = JSON.parse(json);
        } catch (e) {}

        return parsed;
    }

    static objectDeepDiff = (newData: object | any, oldData: object | any) => {
        const record: any = {};
        Object.keys(newData).forEach((key: string) => {
            const newTypeData = typeof newData[key];
            const newDataValue = newData[key];
            const oldDataValue = oldData[key];
            const isAMomentObject = newDataValue ? newDataValue._isAMomentObject : false;
            if (isAMomentObject) {
                if (!isEqual(newDataValue, oldDataValue)) {
                    record[key] = newDataValue.toDate();
                }
            } else if (Array.isArray(newDataValue)) {
                if (!isEqual(newDataValue, oldDataValue)) {
                    record[key] = newDataValue;
                }
            } else if (newTypeData === 'object') {
                if (!isEqual(newDataValue, oldDataValue)) {
                    record[key] = CommonHelper.objectDeepDiff(newDataValue || {}, oldDataValue || {});
                }

                if (isNull(newDataValue) && !isNull(oldDataValue)) {
                    record[key] = null;
                }
            } else {
                if (!isEqual(newDataValue, oldDataValue)) {
                    record[key] = newDataValue;
                }
            }
        });
        return record;
    };

    static isHaveDataChange(objectData: any) {
        if (Array.isArray(objectData)) {
            return true;
        }
        if (objectData === undefined || objectData === null || Object.keys(objectData).length === 0) {
            return false;
        }
        return true;
    }

    static openPopupCenter(url: string, width?: number, height?: number) {
        const pos = {
            x: screen.width / 2 - width / 2,
            y: screen.height / 2 - height / 2
        };

        const features = `width=${width} height=${height} left=${pos.x} top=${pos.y}`;

        return window.open(url, '_blank', features);
    }

    private static makeNewKey(keyProp: string, itr: number, sep: string, obj: any): string {
        const newKey = [keyProp, sep, itr].join('');
        if (Object.keys(obj).indexOf(newKey) === -1) {
            return newKey;
        } else {
            return CommonHelper.makeNewKey(keyProp, ++itr, sep, obj);
        }
    }

    static filterCountry(data: LookupModel, query: string): boolean {
        const searchText = (data.code || '') + ' ' + (data.name || '');
        return searchText.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) >= 0;
    }

    static getErrorMessage(errorRes: HttpErrorResponse): string {
        let message: string = errorRes.error?.error?.message;

        if (message) {
            return message;
        }

        if (errorRes.status === HttpStatusCode.GatewayTimeout) {
            return errorRes.error;
        }

        return errorRes.message;
    }
}
